;(function() {
    const selectors = {
        description: '.hc-description',
      header: 'h6',
      content: 'p'
    }
    const tabs = [];
    const descriptionElem = document.querySelector(selectors.description);
    const addTab = (header, content) => {
      tabs.push({header, content});
      descriptionElem.removeChild(header);
      descriptionElem.removeChild(content);
    };
    const headers = descriptionElem.querySelectorAll(selectors.header);
  
    for (const header of headers) {
      const contentElem = header.nextElementSibling; 
      const isTab =  contentElem && contentElem.matches(selectors.content);
      if (isTab) addTab(header, contentElem);
    }
    const tabsTemplate = document.querySelector('[hc-tabify-template]');
    const tabsContainer = tabsTemplate.querySelector('[hc-tab-container-template]').cloneNode(false);
    const tabElement = tabsTemplate.querySelector('[hc-tab-template]');
    console.log('[HC] Tabify: initialized');
    let i = 0;
    for (const tab of tabs) {
      const tabElems = tabElement.cloneNode(true);
      tabElems.innerHTML = tabElems.innerHTML.replace(/\$\{index\}/g, i++);
      tabElems.querySelector('[hc-tab-header-template]').innerHTML = tab.header.innerHTML;
      tabElems.querySelector('[hc-tab-content-template]').innerHTML = tab.content.innerHTML;
      tabsContainer.append(...tabElems.children);
    }
    descriptionElem.append(tabsContainer);
  })();